import { css } from 'lit';

// language=CSS
export const textarea =
    css`
        textarea {
            display: block;
            height: 5.94rem;
            line-height: 1.19rem;
            padding: 0.625rem 0.625rem;
            width: 100%;
            border: 0;
            box-shadow: var(--sp-default-box-shadow);
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            font-family: "EkMukta-Light";
            font-size: 0.875rem;
            color: #000;
            border-radius: 0.19rem;
        }
    `;
